module.exports = ".display-label-list .button-group, .label-group-list .button-group {\n  padding: 0 20px;\n  margin-bottom: 15px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/component/table-display/table-display.component.scss
// module id = ./src/app/common/component/table-display/table-display.component.scss
// module chunks = common